(function($){
	var sliderCreated = false; // Variable para rastrear si el slider ya se creó

	if ($('.home-featured').length) {
		// Función para verificar la resolución y agregar/eliminar la clase según sea necesario
		function agregarClaseResolucion() {
			const miElemento = $('.home-featured'); // Usamos jQuery para seleccionar el elemento
			const resolucionPequena = window.matchMedia('(max-width: 768px)'); // Cambia 768px a tu tamaño de pantalla deseado
	
			if (resolucionPequena.matches) {
				miElemento.addClass('tiny-featured');
				miElemento.removeClass('flex');
	
				if (!sliderCreated) { // Verifica si el slider aún no se ha creado
					sliderCreated = true; // Establece la variable como verdadera para indicar que el slider se ha creado
					slider = tns({
						container: '.tiny-featured',
						items: 1,
						gutter: 20,
						gutter: 20,
						controls: true,
						mouseDrag: true,
						nav: false,
						autoHeight: true,
						autoplayButtonOutput: false,
						autoplay: true,
						speed: 1200,
						autoplayTimeout: 9000,
						controlsText: ['<span class="fas fa-chevron-left"></span>', '<span class="fas fa-chevron-right"></span>']
					});
				}
	
			} else {
				miElemento.removeClass('tiny-featured');
				miElemento.addClass('flex');
				if (sliderCreated) { // Verifica si el slider se ha creado previamente
					sliderCreated = false; // Establece la variable como falsa para indicar que el slider se ha destruido
					slider.destroy();
				}
			}
		}
	
		// Ejecutar la función al cargar la página y cuando cambie la resolución
		$(document).ready(agregarClaseResolucion);
		$(window).resize(agregarClaseResolucion);
	};
	
	if($('.tiny-1_element').length ) {
		var slider = tns({
			container: '.tiny-1_element',
			items: 1,
			controls: true,
			mouseDrag: true,
			nav: false,
			autoHeight: true,
			autoplayButtonOutput: false,
			autoplay: true,
			speed: 1200,
			autoplayTimeout: 9000,
			autoplayHoverPause: true,
			controlsText: ['<span class="fas fa-chevron-left"></span>', '<span class="fas fa-chevron-right"></span>'],
			});
	};

	if($('.tiny_2_elements').length ) {
		var slider = tns({
			container: '.tiny_2_elements',
			items: 1,
			controls: false,
			mouseDrag: true,
			nav: true,
			navPosition: 'bottom',
			autoplayButtonOutput: false,
			speed: 800,
			responsive: {
				640: {
				  gutter: 20,
				  items: 1
				},
				700: {
				  gutter: 30,
				  items: 2
				}
			  }
		});
	};

	if($('.tiny-3_elements').length ) {
		var slider = tns({
			container: '.tiny-3_elements',
			items: 1,
			controls: false,
			mouseDrag: true,
			nav: true,
			navPosition: 'bottom',
			autoplayButtonOutput: false,
			speed: 800,
			responsive: {
				640: {
				  gutter: 20,
				  items: 2
				},
				700: {
				  gutter: 30
				},
				1024: {
				  items: 3
				}
			  }
		});
	};
	if($('.tiny-4_pre').length ) {
		var slider = tns({
			container: '.tiny-4_pre',
			items: 2,
			gutter: 20,
			controls: true,
			mouseDrag: true,
			nav: false,
			autoplayButtonOutput: false,
			speed: 1000,
			animateDelay:5000,
			autoplay: true,
			autoplayHoverPause: true,
			controlsText: ['<span class="fas fa-chevron-left"></span>', '<span class="fas fa-chevron-right"></span>'],
			responsive: {
				1024: {
				  gutter: 30,
				  items: 4
				}
			  }
		});
	};
	if($('.tiny-4_recents').length ) {
		var slider = tns({
			container: '.tiny-4_recents',
			items: 2,
			gutter: 20,
			controls: true,
			mouseDrag: true,
			nav: false,
			autoplayButtonOutput: false,
			speed: 800,
			autoplayHoverPause: true,
			controlsText: ['<span class="fas fa-chevron-left"></span>', '<span class="fas fa-chevron-right"></span>'],
			responsive: {
				700: {
				  gutter: 30
				},
				1024: {
				  items: 4
				}
			  }
		});
	};
	if($('.tiny-4_recommendeds').length ) {
		var slider = tns({
			container: '.tiny-4_recommendeds',
			items: 2,
			gutter: 20,
			controls: true,
			mouseDrag: true,
			nav: false,
			autoplayButtonOutput: false,
			speed: 800,
			autoplayHoverPause: true,
			controlsText: ['<span class="fas fa-chevron-left"></span>', '<span class="fas fa-chevron-right"></span>'],
			responsive: {
				700: {
				  gutter: 30
				},
				1024: {
				  items: 4
				}
			  }
		});
	};

	if($('.tiny-4_backs').length ) {
		var slider = tns({
			container: '.tiny-4_backs',
			items: 2,
			gutter: 20,
			controls: true,
			mouseDrag: true,
			nav: false,
			autoplayButtonOutput: false,
			speed: 800,
			autoplayHoverPause: true,
			controlsText: ['<span class="fas fa-chevron-left"></span>', '<span class="fas fa-chevron-right"></span>'],
			responsive: {
				700: {
				  gutter: 30
				},
				1024: {
				  items: 4
				}
			  }
		});
	};

	if($('.tiny-5_elements').length ) {
		var slider = tns({
			container: '.tiny-5_elements',
			items: 1,
			controls: false,
			mouseDrag: true,
			nav: true,
			autoplayButtonOutput: false,
			speed: 800,
			autoplayHoverPause: true,
			responsive: {
				640: {
				  gutter: 20,
				  items: 3
				},
				700: {
				  gutter: 30,
				  items: 4
				},
				1024: {
					items: 5
				}
			  }
		});
	};
	$(document).ready(function() {
		// Obtener los parámetros de la URL
		var queryParams = new URLSearchParams(window.location.search);
	
		// Definir los filtros válidos que queremos verificar
		var validFilters = ['product-category', 'location', 'format', 'other-filters'];
		var hasValidFilter = false;
	
		// Comprobar si al menos uno de los filtros válidos está en la URL y tiene un valor
		validFilters.forEach(function(filter) {
			if (queryParams.has(filter) && queryParams.get(filter) !== 'null' && queryParams.get(filter) !== '') {
				hasValidFilter = true;
			}
		});
		// Si al menos un filtro válido está presente, activar los filtros
		if (hasValidFilter) {
			$('.filters-btn.btn-desktop').toggleClass('active');
			$('.filters').toggleClass('active');
	
			if ($('.filters-btn.btn-desktop.active').length) {
				$('.filters-btn.btn-desktop a').text('Hide Filters');
			} else {
				$('.filters-btn.btn-desktop a').text('Show Filters');
			}
		}
	});
	
	
$('.filters-btn').on('click', function()
{
	$('.filters-btn.btn-desktop').toggleClass('active');
	$('.filters').toggleClass('active');
	if($('.filters-btn.btn-desktop.active').length) {
		$('.filters-btn.btn-desktop a').text('Hide Filters');
	}else {
		$('.filters-btn.btn-desktop a').text('Show Filters');	
	}
});
if($('.widget_layered_nav_filters').length) {
	$('.filters-btn').toggleClass('active');
	$('.filters').toggleClass('active');
	if($('.filters-btn.active').length) {
		$('.filters-btn.btn-desktop a').text('Hide Filters');
	}
}
function custom_template(obj){
	var data = $(obj.element).data();
	if(data && data['img_src']){
		img_src = data['img_src'];
		template = $("<div class=\"grid-option\"><img src=\"" + img_src + "\" class=\"w-6;\"/></div>");
		return template;
	}
}
var options = {
'templateSelection': custom_template,
'templateResult': custom_template,
}
$//('.grid-columns').select2(options);
//$('.select2-container--default .select2-selection--single').css({'height': '30px'});


if (!String.prototype.getDecimals) {
	String.prototype.getDecimals = function() {
		var num = this,
			match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
		if (!match) {
			return 0;
		}
		return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
	}
  }
$(".product").on("click", ".quantity input", function() {
	return false;
  });
  $(".product").on("change input", ".quantity .qty", function() {
	var add_to_cart_button = $(this).parents( ".product" ).find(".add_to_cart_button");
	// For AJAX add-to-cart actions
	add_to_cart_button.attr("data-quantity", $(this).val());
	// For non-AJAX add-to-cart actions
	add_to_cart_button.attr("href", "?add-to-cart=" + add_to_cart_button.attr("data-product_id") + "&quantity=" + $(this).val());
  });
  // Trigger on Enter press
  $(".product").on("keypress", ".quantity .qty", function(e) {
	if ((e.which||e.keyCode) === 13) {
	  $( this ).parents(".product").find(".add_to_cart_button").trigger("click");
	}
  });
  
  
  // Quantity "plus" and "minus" buttons
  $(document.body).on('click', '.plus, .minus', function() {
	var $qty = $(this).closest('.quantity').find('.qty'),
		currentVal = parseFloat($qty.val()),
		max = parseFloat($qty.attr('max')),
		min = parseFloat($qty.attr('min')),
		step = $qty.attr('step');
	var $original_qty = $('form.cart .quantity').find('.qty');
	// Format values
	if (!currentVal || currentVal === '' || currentVal === 'NaN') currentVal = 0;
	if (max === '' || max === 'NaN') max = '';
	if (min === '' || min === 'NaN') min = 0;
	if (step === 'any' || step === '' || step === undefined || parseFloat(step) === 'NaN') step = 1;
  
	// Change the value
	if ($(this).is('.plus')) {

		if (max && (currentVal >= max)) {
			$qty.val(max);
			$original_qty.val(max);
		} else {
			$qty.val((currentVal + parseFloat(step)).toFixed(step.getDecimals()));
			$original_qty.val((currentVal + parseFloat(step)).toFixed(step.getDecimals()));

		}
	} else {
		if (min && (currentVal <= min)) {
			$qty.val(min);
			$original_qty.val(min);
		} else if (currentVal > 0) {
			$qty.val((currentVal - parseFloat(step)).toFixed(step.getDecimals()));
			$original_qty.val((currentVal - parseFloat(step)).toFixed(step.getDecimals()));
		}
	}
  
	// Trigger change event
	$qty.trigger('change');
  });

  $('.nav-faqs-item').on('click', function() {
	  var section = $(this).data('section');
	  $('.nav-faqs-item').removeClass('selected');
	  $(this).toggleClass('selected');
	  $('.section').addClass('hidden');
		if(section=== 'all') {
			$('.section').toggleClass('hidden');

		} else {
			$('#'+section).toggleClass('hidden');
		}
  });

  $('.drop-down').on('click', function() {
	  $(this).toggleClass('selected');
  });

  $('.handheld-navigation .item-shop>a').on('click', function(e) {
	if ($(window).width() < 1023) {

	e.preventDefault();
	$('.handheld-navigation .item-shop .sub-menu').toggleClass('active');
	console.log($(window).width())
	}
  })
  $('.menu-toggle').on('click', function(){
	if ($(window).width() < 1023) {

	  if($('.sub-menu').hasClass('active')) {
		  $('.sub-menu').removeClass('active');
	  }
	  if($(this).attr("aria-expanded") === 'true' ) {
			if($('body').hasClass('fixed')) {
				$('body').removeClass('fixed');
			}
		} else {
			$('body').addClass('fixed');
			if($('#wpadminbar').length) {
				$('#wpadminbar').addClass('-mt-20');
			}
	  }
	}
  })

  $('#back-top').on('click', function(e) {
	  e.preventDefault();
	  $('html,body').animate({ scrollTop: 0 }, 'slow');
  });


if($('.wc-block-product-categories__dropdown select').length) {
	$('.wc-block-product-categories__dropdown select').on('change', function () {
		const url = this.value;
		  if ( 'false' !== url ) document.location.href = url;
	})

	$(".guerssen-filter-categories .wc-block-product-categories__dropdown select option:first").text(object_name.some_string);
}
if($('.banner').length){
	var storagebanner = localStorage['banner'];
	if((storagebanner == 'hidden')) {
		if(!$('.banner').hasClass('hidden')) {
			$('.banner').addClass('hidden');
		}
	} else {
		$('.banner').removeClass('hidden');
	}
	$('.banner-close').on('click', function() {
		$('.banner').addClass('hidden');
		localStorage['banner'] = 'hidden';
	});
}

// Iterate over each select element
$('.guerssen-filter-categories select').each(function () {

    // Cache the number of options
    var $this = $(this),
        numberOfOptions = $(this).children('option').length;

    // Hides the select element
    $this.addClass('s-hidden');
	var select_img = $this.children('option:selected').data('img_src');
	if(select_img) {
		// Wrap the select element in a div
		$this.wrap('<div class="select grid-columns"></div>');
	}else{
		// Wrap the select element in a div
		$this.wrap('<div class="select"></div>');
	}

    // Insert a styled div to sit over the top of the hidden select element
    $this.after('<div class="styledSelect"></div>');

    // Cache the styled div
    var $styledSelect = $this.next('div.styledSelect');
	if(select_img) {
	    // Show the first select option in the styled div
		$styledSelect.prepend('<img src="' + select_img + '" />');	
	} else {
		// Show the first select option in the styled div
		$styledSelect.text($this.children('option').eq(0).text());
	}

    // Insert an unordered list after the styled div and also cache the list
    var $list = $('<ul />', {
        'class': 'options'
    }).insertAfter($styledSelect);

    // Insert a list item into the unordered list for each select option
    for (var i = 0; i < numberOfOptions; i++) {
        var current_li = $('<li />', {
            text: $this.children('option').eq(i).text(),
            rel: $this.children('option').eq(i).val(),
        }).appendTo($list);
		var current_img = $this.children('option').eq(i).data('img_src');
		if(current_img) {
			current_li.prepend('<img src="' + current_img + '" />');
		}
    }

    // Cache the list items
    var $listItems = $list.children('li');

    // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
    $styledSelect.click(function (e) {
        e.stopPropagation();
        $('div.styledSelect.active').each(function () {
            $(this).removeClass('active').next('ul.options').hide();
        });
        $(this).toggleClass('active').next('ul.options').toggle();
    });

    // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
    // Updates the select element to have the value of the equivalent option
    $listItems.click(function (e) {
        e.stopPropagation();
		var select_img = $(this).children('img').attr('src');
		console.log(select_img);
		if(select_img) {
			$styledSelect.text('');
			$styledSelect.prepend('<img src="' + select_img + '" />').removeClass('active');
		} else {
			$styledSelect.text($(this).text()).removeClass('active');
		}
        $this.val($(this).attr('rel'));
        $list.hide();
		var form = $(this).parents('form:first');
		if(form.length) {
			form.submit();
		} else {
			if($('.wc-block-product-categories__dropdown select').length) {
					const url = $(this).attr('rel');
					  if ( 'false' !== url ) document.location.href = url;
			
				$(".guerssen-filter-categories .wc-block-product-categories__dropdown select option:first").text(object_name.some_string);
			}
		}
		
        /* alert($this.val()); Uncomment this for demonstration! */
    });

    // Hides the unordered list when clicking outside of it
    $(document).click(function () {
        $styledSelect.removeClass('active');
        $list.hide();
    });

	
});

$('iframe[src*="https://www.youtube.com/embed/"]').addClass("youtube-iframe");
$('iframe[src*="https://www.youtube.com/embed/"]').attr('id', function (index) {
	return "video" + index;
});


var playerSettings = {
	controls: [
	  //'play-large', // The large play button in the center
	  // 'restart', // Restart playback
	  // 'rewind', // Rewind by the seek time (default 10 seconds)
	  'play', // Play/pause playback
	  // 'fast-forward', // Fast forward by the seek time (default 10 seconds)
	  //'progress', // The progress bar and scrubber for playback and buffering
	  //'current-time', // The current time of playback
	  //'duration', // The full duration of the media
	  //'mute', // Toggle mute
	  //'volume', // Volume control
	  // 'captions', // Toggle captions
	  //'settings', // Settings menu
	  // 'pip', // Picture-in-picture (currently Safari only)
	  // 'airplay', // Airplay (currently Safari only)
	  // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
	  'fullscreen', // Toggle fullscreen
	],

  };

const players = Array.from(document.querySelectorAll('.plyr-medias')).map((p) => new Plyr(p,  playerSettings));
players.forEach(function(instance,index) {
	instance.on('play',function(){
		players.forEach(function(instance1,index1){
			if(instance != instance1){
				instance1.pause();
			}
		});
	});
});
window.player = players;


$("input.keyword").keyup(function() {

	$('.button-custom-search').hide();
	$('.button-clean-search').show();
	if ($(this).val().length > 2) {
	  $(".datafetch").show();
	} else {
	  $(".datafetch").hide();
	}
	if ($(this).val().length == 0 ) {
		$('.button-clean-search').hide();
		if ($(window).width() > 960) {
			$('.button-custom-search').show();
		}
	}
  });
$("input.keyword").on('blur', function(){
	this.value='';
	$(document).mouseup(function(e) 
	{
		var container = $(".datafetch");

		// if the target of the click isn't the container nor a descendant of the container
		if (!container.is(e.target) && container.has(e.target).length === 0) 
		{
			$('.datafetch ul').remove();
			$(".datafetch").hide();
			$('.button-clean-search').hide();
			if ($(window).width() > 960) {

			$('.button-custom-search').show();    
			}
		}
	});
});



jQuery(document).ready(function ($) {
    // Inicializar Select2 en los selectores con la clase 'select2'
	if($('.select2').length) {
		$('.select2').select2({
			ajax: {
				url: ajax_object.ajax_url,
				dataType: 'json',
				delay: 250,
				data: function (params) {
					console.log('Datos enviados:', {
						q: params.term,
						action: 'filter_search',
						taxonomy: $(this).attr('id')
					});
					return {
						q: params.term,
						action: 'filter_search',
						taxonomy: $(this).attr('id')
					};
				},
				processResults: function (data) {
					console.log('Datos recibidos:', data);
	
					return {
						results: data
					};
				},
				cache: false
			},
			minimumInputLength: 3
		});
	}
});

$(document).ready(function() {
	$("#modal-close").click(function(e) {
		e.preventDefault(); // Prevent the default behavior of the anchor
		console.log($(this));
		$("#guerssen-modal").fadeOut();
	});
});

})(jQuery);





// When the user scrolls the page, execute myFunction
window.onscroll = function() {myFunction()};

// Get the header
var header = document.getElementById("masthead");

var navigation = document.getElementById("site-navigation");
var button = document.getElementsByClassName("menu-toggle");
var back_top = document.getElementById("back-top");
// Get the offset position of the navbar
var sticky = navigation.offsetTop;
// Add the sticky class to the navigation when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
	if (window.pageYOffset > sticky + 80) {
		navigation.classList.add("menu-fixed");
		header.classList.add("fixed");
	} else {
		navigation.classList.remove("menu-fixed");
		header.classList.remove("fixed");	
	}
	if(back_top) {
		if (window.pageYOffset > document.body.offsetHeight-1550) {
			back_top.style.opacity = 1;
		} else {
			back_top.style.opacity = 0;
		}
	}
}
var lastScrollTop = 0;

window.addEventListener("scroll", function(){  
	var st = window.pageYOffset || document.documentElement.scrollTop;  
	if (st > lastScrollTop){
       header.style.top = "-100%";
	   button[0].style.top = "-200px";
   } else {
      header.style.top = "0";
	  button[0].style.top = "1.5rem";

   }
   lastScrollTop = st;
}, false);

